const pubsub = {
  events: {},
  on: function(eventName, fn) {
    this.events[eventName] = this.events[eventName] || [];
    this.events[eventName].push(fn);
  },
  off: function(eventName, fn) {
    if (this.events[eventName]) {
      this.events[eventName].forEach((event, index) => {
        if (event === fn) {
          this.events[eventName].splice(index, 1);
        }
      });
    }
  },
  emit: function(eventName, data) {
    if (this.events[eventName]) {
      this.events[eventName].forEach(function(fn) {
        fn(data);
      });
    }
  }
};
export {
  pubsub as p
};
